import { Pipe, PipeTransform } from '@angular/core';
import { NavItem, NavLink, NavMenu } from '../models/nav.model';

@Pipe({
  name: 'isNavMenu',
  pure: true,
  standalone: true,
})
export class isNavMenuPipe implements PipeTransform {
  transform(navItem: NavItem): navItem is NavMenu {
    return 'items' in navItem;
  }
}

@Pipe({
  name: 'isNavLink',
  pure: true,
  standalone: true,
})
export class isNavLinkPipe implements PipeTransform {
  transform(navItem: NavItem): navItem is NavLink {
    return 'path' in navItem;
  }
}

const hasSubNav = (navItem: NavItem): boolean => {
  return (
    'items' in navItem &&
    navItem.items !== undefined &&
    navItem.items.length > 1
  );
};

@Pipe({
  name: 'hasSubNavItems',
  pure: true,
  standalone: true,
})
export class hasSubNavItemsPipe implements PipeTransform {
  transform(navItem: NavItem): navItem is NavLink | NavMenu {
    return hasSubNav(navItem);
  }
}
@Pipe({
  name: 'hideNavItems',
  pure: true,
  standalone: true,
})
export class hideNavItemsPipe implements PipeTransform {
  transform(navItem: NavItem): navItem is NavLink | NavMenu {
    return !hasSubNav(navItem);
  }
}
